module.exports = __webpack_public_path__ + "static/media/turn-table.4f75dcc2.png";